module.exports = "<iframe id=\"mapFrame\" ng-if=\"vm.mapUrlsLoaded\" class=\"map\" src=\"{{vm.url}}\" frameborder=\"0\" width=\"100%\" height=\"100%\" allowfullscreen prevent-scroll></iframe>\r\n\r\n<object-data-modal ng-if=\"vm.selectedObject\" modal-opened=\"vm.objectDataModalOpen\" object=\"vm.selectedObject\"></object-data-modal>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/shared/directives/object-results-mapview.directive.html
 ** module id = 65
 ** module chunks = 0
 **/